import {correctiveInteraction as productCategoryAssignment} from "./product-category-assignment";

/**
 * Maps datasource id → interactive correction section configs.
 */
export const correctiveInteractionRegistry = {
    [productCategoryAssignment.datasourceId]: productCategoryAssignment.sections,
};